export const PROTECTED_BRANCH_REASON = "This branch is protected. Use a change request.";

export const PROTECTED_BRANCH_ARCHIVE_REASON = "Protected branches can't be archived.";

export const DEFAULT_BRANCH_ARCHIVE_REASON = "The default branch can't be archived.";

export function isBranchProtectionGated(
  branch: { isProtected: boolean } | null | undefined,
  protectedBranchesEnabled: boolean,
): boolean {
  return protectedBranchesEnabled && branch?.isProtected === true;
}
